import { Country, Region } from '../types';

import { sortOrder_AT, sortOrder_DE } from './Airports';

export const regionMap: Record<Region, string> = {
    [Region.North]: 'TRANS-north',
    [Region.East]: 'TRANS-east',
    [Region.South]: 'TRANS-south',
    [Region.West]: 'TRANS-west',
};
export const countryMap: Record<Country, string> = {
    [Country.Austria]: 'TRANS-Austria',
    [Country.Belgium]: 'TRANS-Belgium',
    [Country.CzechRepublic]: 'TRANS-Czech-Republic',
    [Country.Denmark]: 'TRANS-Denmark',
    [Country.France]: 'TRANS-France',
    [Country.Germany]: 'TRANS-Germany',
    [Country.Italy]: 'TRANS-Italy',
    [Country.Luxembourg]: 'TRANS-Luxembourg',
    [Country.Netherlands]: 'TRANS-Netherlands',
    [Country.Poland]: 'TRANS-Poland',
    [Country.Slovakia]: 'TRANS-Slovakia',
    [Country.Slovenia]: 'TRANS-Slovenia',
    [Country.Switzerland]: 'TRANS-Switzerland',
};
export const countryCodeMap: Record<string, Country> = {
    AT: Country.Austria,
    BE: Country.Belgium,
    CZ: Country.CzechRepublic,
    DK: Country.Denmark,
    F: Country.France,
    DE: Country.Germany,
    LU: Country.Luxembourg,
    NL: Country.Netherlands,
    PL: Country.Poland,
    IT: Country.Italy,
    SI: Country.Slovenia,
    SK: Country.Slovakia,
    CH: Country.Switzerland,
};

// map sort order by country code
export const countrySortMap: Record<string, Country[]> = {
    DE: sortOrder_DE,
    AT: sortOrder_AT,
};
